/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class DayPickerController {
    public static $inject = [
        '$scope',
    ];

    public scope;

    constructor($scope, $log) {
        $scope.todayDt =  new Date();

        $scope.disabled = function(date) {
          return ( date.getDay() === 5 || date.getDay() === 6 );
        };
    }
}

angular.module('schemaForm')
    .controller('DayPickerController', DayPickerController);



// WEBPACK FOOTER //
// ./frontend/scripts/schemaForm/controllers/daypicker.controller.ts